module.exports = __webpack_public_path__ + "img/1 (25).d9aa580c.png";